import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const GlobalContext = createContext();

export const useGlobal = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    teams_scheduling_url: 'https://outlook.office.com/bookwithme/user/d4e9db6b4db44514afc2bdb7653950ba@trinity-tw.com/meetingtype/3vhUyvD7tE6rkPuBIowaDQ2?anonymous&ep=mlink',
    motorcycle_ecommerce_url: 'https://www.anchilex.com',
    company_name: '',
    company_phone: '+886-2-XXXX-XXXX',
    company_email: 'info@trinity-tw.com',
    company_address: 'Taipei, Taiwan',
    logo_url: 'https://customer-assets.emergentagent.com/job_image-tech-hub/artifacts/dmgnw69g_%E5%B7%A5%E4%BD%9C%E5%8D%80%E5%9F%9F%2016.png',
    linkedin_url: '',
    facebook_url: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/global-settings`);
        if (response.data) {
          // Merge all settings from API, using fallbacks only for critical display fields
          setSettings(prev => ({
            ...prev,
            ...response.data,
            teams_scheduling_url: response.data.teams_scheduling_url || prev.teams_scheduling_url,
            motorcycle_ecommerce_url: response.data.motorcycle_ecommerce_url || prev.motorcycle_ecommerce_url,
            logo_url: response.data.logo_url || prev.logo_url,
            // Company name should use exact value from API
            company_name: response.data.company_name ?? '',
            // Social URLs should use exact values from API (empty string = hide icon)
            linkedin_url: response.data.linkedin_url ?? '',
            facebook_url: response.data.facebook_url ?? ''
          }));
        }
      } catch (error) {
        console.log('Using default settings');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  return (
    <GlobalContext.Provider value={{ settings, setSettings, loading, API }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
